export default {
  login: (code) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false; JSESSIONID=DEEA378B159C5239FB5A0809486C2F71; wrikeForceSSO=false");
    
    var urlencoded = new URLSearchParams();
    urlencoded.append("client_id", "atPjwZdB");
    urlencoded.append("client_secret", "Uca095WC6FXfBSRFbIJBc9RsOmC1VRbfW8vsHWtVuxSbtiOQ4hvhw4WmXr6F3UZZ");
    urlencoded.append("grant_type", "authorization_code");
    urlencoded.append("code", code);
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
    };
    
    return fetch("https://login.wrike.com/oauth2/token", requestOptions)
    .then(res => res.json())
  },
};
